/* Copyright (c) 2020 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";

type FlexContainerProps = {
  justify?: string;
  direction?: string;
  align?: string;
  space?: string;
  background?: string;
  grow?: boolean;
  width?: string;
  height?: string;
  wrap?: string;
  gap?: string;
};

const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  flex-wrap: ${({ wrap }) => wrap || `no-wrap`};
  flex-direction: ${({ direction }) => direction || `row`};
  justify-content: ${({ justify }) => justify || `flex-start`};
  align-items: ${({ align }) => align || `center`};
  margin: ${({ space }) => space || `0`};
  background: ${({ background }) => background || "transparent"};
  flex-grow: ${({ grow }) => `${grow ? "100" : ""}`};
  width: ${({ width }) => `${width}`};
  height: ${({ height }) => `${height}`};
  gap: ${({ gap }) => `${gap}`};
`;

export default FlexContainer;
